var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Layout', [_vm.loading || _vm.error ? _c('LoaderIcon', {
    attrs: {
      "error": _vm.error
    }
  }) : _c('div', [_c('GrayHeader', [_c('MottoBreadcrumbs', {
    attrs: {
      "items": [{
        label: _vm.selectedPersonnelOffice.tradeName,
        routeName: 'myInfo',
        routeParams: {
          selectOfficeId: _vm.selectedPersonnelOffice.id
        }
      }],
      "back-route": 'myInfo',
      "back-route-params": {
        selectOfficeId: _vm.selectedPersonnelOffice.id
      }
    }
  }), _c('BaseTitle', {
    staticClass: "color-primary-blue",
    class: _vm.$style.title
  }, [_vm._v(_vm._s(_vm.pageTitle))])], 1), _c('div', {
    class: _vm.$style.formStemTitleContainer
  }, [_c('h3', {
    class: _vm.$style.formStepTitle
  }, [_vm._v(_vm._s(_vm.formStepTitle))])]), _c('h3', {
    class: _vm.$style.formStepTitleMobile
  }, [_vm._v(_vm._s(_vm.formStepTitle))]), _c('div', {
    class: _vm.$style.formStepsContainer
  }, [_c('Transition', {
    attrs: {
      "name": _vm.currentStepAnimation
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentStep === _vm.steps.ROLE_SELECTION,
      expression: "currentStep === steps.ROLE_SELECTION"
    }]
  }, [_c('ValidationObserver', {
    ref: "formStep1",
    attrs: {
      "immediate": ""
    }
  }, [_c('PersonnelFormItemGroup', {
    class: _vm.$style.groupMargin
  }, [_c('PersonnelFormItemCheckbox', {
    attrs: {
      "label": "Office Employee",
      "edit-mode": !_vm.reviewMode,
      "value": _vm.roles,
      "checkbox-sub-labels": _vm.roleOptionsSubLabels,
      "multi-select": "",
      "disabled": _vm.isThirdParty,
      "edit-checkbox-values": _vm.roleOptions,
      "exclusive-values": [['LOA - Licensed', 'LOA - Unlicensed'], ['Loan Originator Phase 1', 'Loan Originator Phase 2']],
      "placeholder": "Select..."
    },
    on: {
      "update:value": function updateValue($event) {
        _vm.roles = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('p', {
          staticClass: "button-text bold mb-3"
        }, [_vm._v("Choose all that apply: ")])];
      },
      proxy: true
    }])
  })], 1), _c('PersonnelFormItemGroup', {
    class: _vm.$style.groupMargin
  }, [_c('PersonnelFormItemCheckbox', {
    attrs: {
      "label": "Contractor",
      "edit-mode": !_vm.reviewMode,
      "value": _vm.roles,
      "checkbox-sub-labels": _vm.roleOptionsSubLabels,
      "multi-select": "",
      "edit-checkbox-values": _vm.thirdPartyRoleOptions,
      "placeholder": "Select..."
    },
    on: {
      "update:value": function updateValue($event) {
        _vm.roles = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('p', {
          staticClass: "button-text mb-3"
        }, [_vm._v("Contractor: ")])];
      },
      proxy: true
    }])
  })], 1)], 1)], 1)]), _c('Transition', {
    attrs: {
      "name": _vm.currentStepAnimation
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentStep === _vm.steps.MLO_PHASE_SELECTION,
      expression: "currentStep === steps.MLO_PHASE_SELECTION"
    }]
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('h3', {
    staticClass: "color-secondary-red"
  }, [_vm._v("BEFORE FILLING OUT THE FORM:")]), _c('p', {
    staticClass: "button-text"
  }, [_vm._v(" Please go to "), _c('a', {
    attrs: {
      "href": "https://www.nmlsconsumeraccess.org",
      "target": "_blank"
    }
  }, [_vm._v("www.nmlsconsumeraccess.org")]), _vm._v(" and check if the LO is showing "), _c('i', [_vm._v("Authorized to Represent")]), _vm._v(" & has an active state license as shown in the screenshot below. ")])]), _c('div', {
    class: _vm.$style.loInstructionsImageContainer
  }, [_c('div', [_c('img', {
    class: [_vm.$style.requiredStepImage, _vm.$style.groupMargin],
    attrs: {
      "src": require("@assets/images/userCreationComplete.jpg"),
      "alt": "Required User Creation Complete"
    }
  })])]), _c('div', {
    class: _vm.$style.loInstructionsImageContainerMobile
  }, [_c('div', [_c('img', {
    class: [_vm.$style.requiredStepImage, _vm.$style.groupMargin],
    attrs: {
      "src": require("@assets/images/userCreationStep2.jpg"),
      "alt": "Required User Creation Step 1"
    }
  })]), _c('div', [_c('img', {
    class: _vm.$style.requiredStepImage,
    attrs: {
      "src": require("@assets/images/userCreationStep.jpg"),
      "alt": "Required User Creation Step 1"
    }
  })])]), _c('div', {
    class: _vm.$style.formGroup
  }, [_c('p', {
    staticClass: "button-text"
  }, [_vm._v(" As shown in the screenshot above, is the LO showing Authorized to Represent the Motto Mortgage office and an active state license on the NMLS website ( "), _c('a', {
    attrs: {
      "href": "https://www.nmlsconsumeraccess.org",
      "target": "_blank"
    }
  }, [_vm._v("www.nmlsconsumeraccess.org")]), _vm._v(" )? ")]), _c('div', {
    class: _vm.$style.buttonsContainer
  }, [!_vm.requestingPhaseTwoAccess ? _c('BaseRadioButton', {
    attrs: {
      "label": "No (Phase 1: Training Access)",
      "value": 1,
      "name": "loPhase"
    },
    model: {
      value: _vm.loPhase,
      callback: function callback($$v) {
        _vm.loPhase = $$v;
      },
      expression: "loPhase"
    }
  }) : _vm._e(), _c('BaseRadioButton', {
    attrs: {
      "label": "Yes (Phase 2: Full Access)",
      "value": 2,
      "name": "loPhase"
    },
    model: {
      value: _vm.loPhase,
      callback: function callback($$v) {
        _vm.loPhase = $$v;
      },
      expression: "loPhase"
    }
  })], 1)])])]), _c('Transition', {
    attrs: {
      "name": _vm.currentStepAnimation
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentStep === _vm.steps.COMPLIANCE,
      expression: "currentStep === steps.COMPLIANCE"
    }]
  }, [_c('ValidationObserver', {
    ref: "formStep4",
    attrs: {
      "immediate": ""
    }
  }, [_vm.isLoPhaseTwo ? _c('PersonnelFormItemGroup', {
    class: _vm.$style.groupMargin
  }, [_c('FormItem', {
    attrs: {
      "label": "NMLS #",
      "value": _vm.user.nmlsNumber,
      "edit-mode": !_vm.reviewMode,
      "placeholder": "NMLS #",
      "mask": '#*',
      "rules": "required"
    },
    on: {
      "update:value": function updateValue($event) {
        return _vm.$set(_vm.user, "nmlsNumber", $event);
      }
    }
  })], 1) : _vm._e(), _vm.isLoPhaseTwo ? _c('PersonnelFormItemGroup', {
    class: _vm.$style.groupMargin
  }, [_c('FormItem', {
    attrs: {
      "label": "ORM Location Description",
      "placeholder": _vm.getLocationDetailsPlaceholder,
      "value": _vm.user.locationDetails,
      "sub-label": "The following will be used to fill in any website listing descriptions on websites such as Google, Bing, Yelp, and many more. If you would like something else please enter your own description below:",
      "edit-mode": !_vm.reviewMode,
      "textarea": "",
      "rules": "max:750"
    },
    on: {
      "update:value": function updateValue($event) {
        return _vm.$set(_vm.user, "locationDetails", $event);
      }
    }
  })], 1) : _vm._e(), _vm.isLoPhaseTwo ? _c('PersonnelFormItemGroup', {
    class: _vm.$style.groupMargin
  }, [_c('PersonnelFormItemLicenseStates', {
    attrs: {
      "label": 'State(s) of Licensure',
      "sub-label": 'Choose all that apply',
      "edit-mode": !_vm.reviewMode,
      "value": _vm.selectedStates,
      "edit-select-values": _vm.getOfficeLicensesAreas,
      "disabled": !_vm.getOfficeLicensesAreas.length,
      "placeholder": _vm.getOfficeLicensesAreas.length ? 'Select...' : 'No states are eligible for this user',
      "rules": "required"
    },
    on: {
      "update:value": function updateValue($event) {
        _vm.selectedStates = $event;
      }
    }
  })], 1) : _vm._e(), _vm.isLoPhaseTwo ? _c('PersonnelFormItemGroup', {
    class: _vm.$style.groupMargin
  }, [_c('FormItem', {
    attrs: {
      "label": "Notes",
      "value": _vm.user.notes,
      "edit-mode": !_vm.reviewMode,
      "placeholder": "Use this field to describe any special considerations related to this request"
    },
    on: {
      "update:value": function updateValue($event) {
        return _vm.$set(_vm.user, "notes", $event);
      }
    }
  })], 1) : _vm._e()], 1)], 1)]), _c('Transition', {
    attrs: {
      "name": _vm.currentStepAnimation
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentStep === _vm.steps.BASIC_INFO,
      expression: "currentStep === steps.BASIC_INFO"
    }]
  }, [_c('ValidationObserver', {
    ref: "formStep2",
    attrs: {
      "immediate": ""
    }
  }, [_c('PersonnelFormItemGroup', {
    class: _vm.$style.groupMargin
  }, [_c('FormItem', {
    attrs: {
      "label": "First Name",
      "value": _vm.user.firstName,
      "edit-mode": !_vm.reviewMode,
      "placeholder": "First Name",
      "rules": "required|max:70",
      "character-limit-options": {
        showOnlyError: true
      }
    },
    on: {
      "update:value": function updateValue($event) {
        return _vm.$set(_vm.user, "firstName", $event);
      },
      "update": _vm.loadEmailOptionsDebounce
    }
  }), _c('FormItem', {
    attrs: {
      "label": "Last Name",
      "value": _vm.user.lastName,
      "edit-mode": !_vm.reviewMode,
      "placeholder": "Last Name",
      "rules": "required|max:70",
      "character-limit-options": {
        showOnlyError: true
      }
    },
    on: {
      "update:value": function updateValue($event) {
        return _vm.$set(_vm.user, "lastName", $event);
      },
      "update": _vm.loadEmailOptionsDebounce
    }
  }), _c('FormItem', {
    attrs: {
      "label": "Job Title",
      "value": _vm.user.jobTitle,
      "edit-mode": !_vm.reviewMode,
      "rules": "max:60",
      "character-limit-options": {
        showOnlyError: true
      },
      "placeholder": "Job Title"
    },
    on: {
      "update:value": function updateValue($event) {
        return _vm.$set(_vm.user, "jobTitle", $event);
      }
    }
  })], 1), _c('PersonnelFormItemGroup', {
    class: _vm.$style.groupMargin
  }, [_c('FormItem', {
    style: [_vm.reviewMode ? {
      'flex-grow': '1'
    } : {
      'flex-grow': '5'
    }],
    attrs: {
      "label": "Work line",
      "value": _vm.user.phone,
      "mask": '###-###-####',
      "edit-mode": !_vm.reviewMode,
      "rules": "required|validPhoneNumber",
      "placeholder": "xxx-xxx-xxxx"
    },
    on: {
      "update:value": function updateValue($event) {
        return _vm.$set(_vm.user, "phone", $event);
      }
    }
  }), _c('FormItem', {
    attrs: {
      "label": "Ext.",
      "value": _vm.user.phoneExt,
      "placeholder": "Work line Ext.",
      "mask": '######',
      "edit-mode": !_vm.reviewMode,
      "name": "Work line Ext."
    },
    on: {
      "update:value": function updateValue($event) {
        return _vm.$set(_vm.user, "phoneExt", $event);
      }
    }
  })], 1), _c('PersonnelFormItemGroup', {
    staticClass: "mb-3"
  }, [_c('FormItem', {
    style: [_vm.reviewMode ? {
      'flex-grow': '1'
    } : {
      'flex-grow': '5'
    }],
    attrs: {
      "label": "Mobile Number",
      "value": _vm.isMobileNumberSameAsWorkline ? _vm.user.phone : _vm.user.phoneMobile,
      "mask": '###-###-####',
      "disabled": _vm.isMobileNumberSameAsWorkline,
      "edit-mode": !_vm.reviewMode,
      "rules": 'required|validPhoneNumber',
      "placeholder": "xxx-xxx-xxxx"
    },
    on: {
      "update:value": function updateValue($event) {
        return _vm.$set(_vm.isMobileNumberSameAsWorkline ? _vm.user.phone : _vm.user, "phoneMobile", $event);
      }
    }
  }), _c('FormItem', {
    attrs: {
      "label": "Ext.",
      "value": _vm.isMobileNumberSameAsWorkline ? _vm.user.phoneExt : _vm.user.phoneMobileExt,
      "disabled": _vm.isMobileNumberSameAsWorkline,
      "placeholder": "Mobile Ext.",
      "edit-mode": !_vm.reviewMode,
      "name": "Mobile Number Ext.",
      "mask": '######'
    },
    on: {
      "update:value": function updateValue($event) {
        return _vm.$set(_vm.isMobileNumberSameAsWorkline ? _vm.user.phoneExt : _vm.user, "phoneMobileExt", $event);
      }
    }
  })], 1), _c('div', {
    class: [_vm.$style.groupMargin, _vm.$style.mobileNumberCheckboxes]
  }, [!_vm.reviewMode ? _c('BaseCheckbox', {
    staticClass: "mr-3",
    attrs: {
      "label": "Same as Work line",
      "input-value": "true"
    },
    model: {
      value: _vm.mobileSameAsWorkline,
      callback: function callback($$v) {
        _vm.mobileSameAsWorkline = $$v;
      },
      expression: "mobileSameAsWorkline"
    }
  }) : _vm._e(), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('BaseCheckbox', {
    staticClass: "mr-2",
    class: [_vm.isMobileNumberValid ? '' : 'pe-none'],
    attrs: {
      "label": "Publish to Web",
      "input-value": "1"
    },
    model: {
      value: _vm.publishToWeb,
      callback: function callback($$v) {
        _vm.publishToWeb = $$v;
      },
      expression: "publishToWeb"
    }
  }), _c('Tooltip', {
    attrs: {
      "target": 'publish-to-web',
      "icon-absolute-position": false,
      "placement": "top",
      "theme": "blue"
    }
  }, [_vm._v(" Checking this box will publish your Mobile number on the web. ")])], 1)], 1), _c('PersonnelFormItemGroup', {
    class: _vm.$style.groupMargin
  }, [_c('FormItem', {
    attrs: {
      "label": "Time Zone",
      "edit-mode": !_vm.reviewMode,
      "value": _vm.timezone,
      "rules": 'required',
      "edit-select-values": _vm.getTimeZoneOptions,
      "placeholder": "Select..."
    },
    on: {
      "update:value": function updateValue($event) {
        _vm.timezone = $event;
      }
    }
  }), _c('FormItemBirthDay', {
    attrs: {
      "edit-mode": !_vm.reviewMode,
      "birth-day": _vm.user.birthDay,
      "birth-month": _vm.user.birthMonth
    },
    on: {
      "update:birthDay": function updateBirthDay($event) {
        return _vm.$set(_vm.user, "birthDay", $event);
      },
      "update:birth-day": function updateBirthDay($event) {
        return _vm.$set(_vm.user, "birthDay", $event);
      },
      "update:birthMonth": function updateBirthMonth($event) {
        return _vm.$set(_vm.user, "birthMonth", $event);
      },
      "update:birth-month": function updateBirthMonth($event) {
        return _vm.$set(_vm.user, "birthMonth", $event);
      }
    }
  })], 1)], 1)], 1)]), _c('Transition', {
    attrs: {
      "name": _vm.currentStepAnimation
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentStep === _vm.steps.MOTTO_EMAIL,
      expression: "currentStep === steps.MOTTO_EMAIL"
    }]
  }, [_c('ValidationObserver', {
    ref: "formStep5",
    attrs: {
      "immediate": ""
    }
  }, [!_vm.isThirdParty ? _c('PersonnelFormItemGroup', {
    class: _vm.$style.groupMargin
  }, [_vm.loadingEmailOptions ? _c('LoaderIcon') : _vm._e(), !_vm.loadingEmailOptions ? _c('FormItem', {
    attrs: {
      "label": "Motto Email",
      "edit-mode": !_vm.reviewMode,
      "rules": _vm.isThirdParty ? '' : 'required',
      "edit-select-values": _vm.emailOptions,
      "placeholder": "Select...",
      "value": _vm.user.primaryEmail
    },
    on: {
      "update:value": function updateValue($event) {
        return _vm.$set(_vm.user, "primaryEmail", $event);
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _c('PersonnelFormItemGroup', {
    class: _vm.$style.groupMargin
  }, [_c('FormItem', {
    attrs: {
      "label": "Personal Email",
      "value": _vm.user.secondaryEmail,
      "sub-label": "This should NOT be a @mottomortgage.com email. It should be the personal email for the new user to receive their MottoCenter activation email to.",
      "edit-mode": !_vm.reviewMode,
      "placeholder": "Personal Email",
      "character-limit-options": {
        showOnlyError: true
      },
      "rules": "required|email|max:75"
    },
    on: {
      "update:value": function updateValue($event) {
        return _vm.$set(_vm.user, "secondaryEmail", $event);
      }
    }
  })], 1)], 1)], 1)])], 1), _c('div', {
    class: _vm.$style.formStepsButtons
  }, [_vm.canDecreaseStep ? _c('BaseButton', {
    attrs: {
      "disabled": !_vm.canDecreaseStep
    },
    on: {
      "click": _vm.decreaseStep
    }
  }, [_vm._v("Back")]) : _vm._e(), !_vm.canDecreaseStep ? _c('div') : _vm._e(), _c('div', {
    staticClass: "d-flex"
  }, [_c('BaseButton', {
    staticClass: "mr-5",
    attrs: {
      "theme": "white"
    },
    on: {
      "click": _vm.cancelForm
    }
  }, [_vm._v("Cancel")]), !_vm.isFinalStep ? _c('BaseButton', {
    attrs: {
      "disabled": !_vm.isFormValid(_vm.currentStep) || !_vm.canIncreaseStep
    },
    on: {
      "click": _vm.increaseStep
    }
  }, [_vm._v(" Next ")]) : _vm._e(), _vm.isFinalStep ? _c('BaseButton', {
    attrs: {
      "theme": "green",
      "disabled": !_vm.isFormValid(_vm.currentStep)
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm.submitting ? [_c('BaseIcon', {
    attrs: {
      "name": "spinner",
      "spin": ""
    }
  })] : [_vm._v("Submit")]], 2) : _vm._e()], 1)], 1), _c('div', {
    class: _vm.$style.formStepsButtonsMobile
  }, [_vm.canDecreaseStep ? _c('BaseButton', {
    attrs: {
      "disabled": !_vm.canDecreaseStep
    },
    on: {
      "click": _vm.decreaseStep
    }
  }, [_vm._v("Back")]) : _vm._e(), !_vm.canDecreaseStep ? _c('div') : _vm._e(), _c('div', {
    staticClass: "d-flex",
    class: _vm.$style.cancelButtonContainerMobile
  }, [_c('BaseButton', {
    attrs: {
      "theme": "white"
    },
    on: {
      "click": _vm.cancelForm
    }
  }, [_vm._v("Cancel")]), !_vm.isFinalStep ? _c('BaseButton', {
    attrs: {
      "disabled": !_vm.isFormValid(_vm.currentStep) || !_vm.canIncreaseStep
    },
    on: {
      "click": _vm.increaseStep
    }
  }, [_vm._v(" Next ")]) : _vm._e(), _vm.isFinalStep ? _c('BaseButton', {
    attrs: {
      "theme": "green",
      "disabled": !_vm.isFormValid(_vm.currentStep)
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm.submitting ? [_c('BaseIcon', {
    attrs: {
      "name": "spinner",
      "spin": ""
    }
  })] : [_vm._v("Submit")]], 2) : _vm._e()], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }